export const isString = (whatever: any): whatever is string =>
  typeof whatever === "string";

export const isEmptyString = (str: string): boolean =>
  isString(str) && str.length === 0;

export const isNotEmptyStr = (str: string): boolean =>
  isString(str) && str.length > 0;

export const isAry = (ary: any[]): boolean => {
  const typeCheck: {} = {};
  return ary && typeCheck.toString.call(ary) === "[object Array]";
};

export const isEmptyAry = (ary: any[]): boolean =>
  isAry(ary) && ary.length === 0;

export const isNotSet = (any: any): any is null | undefined =>
  any === undefined || any === null;

export const isSet = <Whatever>(
  any: null | undefined | Whatever
): any is Whatever => !isNotSet(any);

export const isScreenLessThanWidth = (width: number) =>
  window.innerWidth < width;

export const isFloat = (num: number): boolean => num % 1 !== 0;
